import styled from 'styled-components';

export const ListContent = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  margin-top: 15px;
  font-family: 'Inter', sans-serif;
  box-sizing: border-box;
`;

export const ErrorMessage = styled.div`
  padding: 24px;
  color: #b91c1c;
  font-size: 0.9rem;
`;

export const StatusTag = styled.span<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 2rem;
  font-size: 0.7rem;
  font-weight: 600;
  background: ${({ $active }) => ($active ? '#dcfce7' : '#f3f4f6')};
  color: ${({ $active }) => ($active ? '#166534' : '#6b7280')};
`;
